import React from 'react'

import './modal.css'

const ModalConfirm = ({children, title, showPopup}) => {



    
    return (
        <div className='modal-container'>
            <div className='modal-popup'>
                <div className='modal-header'>
                    <h2>{title}</h2>
                    <button onClick={showPopup}>X</button>
                </div>
                {children}
            </div>
        </div>
    )
}

export default ModalConfirm
